import { Component, OnInit } from '@angular/core';
import {InvoiceTemplateBase} from '../invoce-template-base';

@Component({
  selector: 'eci-import-invoice-form',
  templateUrl: './import-invoice-form.component.html',
  styleUrls: ['./import-invoice-form.component.scss']
})
export class ImportInvoiceFormComponent extends InvoiceTemplateBase implements OnInit {

  ngOnInit(): void {
      this.model = {
          ...this.template,
          ...this.invoice,
          customerCompany: {
              ...this.template.customerCompany,
              ...this.invoice.customerCompany
          }
      };
  }

}
